/* eslint-disable import/prefer-default-export */
import anime from 'animejs';

export function animateAddCart(button) {
  return new Promise((resolve) => {
    const badgeDom = document.querySelector('.page-header-cart-count');

    if (button && badgeDom) {
      const fromState = {
        top: `${button.getBoundingClientRect().top}px`,
        right: `${window.innerWidth - button.getBoundingClientRect().right + 2}px`,
        left: `${button.getBoundingClientRect().left}px`,
        width: `${button.getBoundingClientRect().width}px`,
        height: `${button.getBoundingClientRect().height}px`,
      };

      const toState = {
        top: `${badgeDom.getBoundingClientRect().top}px`,
        right: `${window.innerWidth - badgeDom.getBoundingClientRect().right}px`,
        left: `${badgeDom.getBoundingClientRect().left}px`,
        width: `${badgeDom.getBoundingClientRect().width}px`,
        height: `${badgeDom.getBoundingClientRect().height}px`,
      };

      const circleAnimateDom = document.querySelector('.add-cart-animate-placeholder');
      if (button && circleAnimateDom) {
        button.style.visibility = 'hidden';
        circleAnimateDom.style.visibility = 'visible';
        circleAnimateDom.style.opacity = '1';
        circleAnimateDom.style.zIndex = '200';

        Object.keys(fromState).forEach((prop) => (circleAnimateDom.style[prop] = fromState[prop]));

        anime
          .timeline()
          .add({
            targets: circleAnimateDom,
            width: fromState.height,
            height: fromState.height,
            top: fromState.top,
            right: toState.right,
            left: toState.left,
            easing: 'easeOutSine',
            duration: 100,
          })
          .add({
            targets: circleAnimateDom,
            width: toState.width,
            height: toState.height,
            top: toState.top,
            right: toState.right,
            left: toState.left,
            easing: 'easeOutCirc',
            duration: 300,
          })
          .finished.then(() => {
            circleAnimateDom.style.opacity = '0';
            circleAnimateDom.style.zIndex = '0';
            button.style.visibility = 'visible';
            resolve();
          });
      } else {
        resolve();
      }
    } else {
      resolve();
    }
  });
}
